/* Página principal del sistema, llamada después de la autentificación */

//*react- recursos
  import { useState, useEffect } from "react";
  import shallow from 'zustand/shallow';

//*otros recursos  
  import $ from 'jquery';

//*componentes-utiles
  import VentanaObjErrorAPI from "../../componentes/generaVentana/VentanaObjErrorAPI";

//*clases 
  import './paginaSSC.css';

//*datos

//*archivos & componentes (imagenes y elementos necesarios para la rutina)
  import Encabezado  from "./encabezado/Encabezado"
  import Contenido from "./contenido/Contenido";
  import Pie from "./pie/Pie";

//*api's (servicios y store)
  import authenticateStore   from "../../api/recursos/authenticate/authenticate.store"; 
  import catalogsStore       from "../../api/recursos/catalogs/catalogs.store"; 
  import proposalsStore      from "../../api/recursos/proposals/proposals.store"; 
  import decisionsStore      from "../../api/recursos/decisions/decisions.store"; 
  import ptCatalogsStore     from "../../api/recursos/ptCatalogs/ptCatalogs.store"; 
  import filesStore          from "../../api/recursos/files/files.store"; 
  import analysisStore       from "../../api/recursos/analysis/analysis.store"; 
  import dashboardStore      from "../../api/recursos/dashboard/dashboard.store"; 
  import configurationsStore from "../../api/recursos/configurations/configurations.store"; 

  import usersStore   from "../../api/recursos/users/users.store";

  import notificationsStore   from "../../api/recursos/notifications/notifications.store";
  import notificationsService from "../../api/recursos/notifications/notifications.servicio";

//*función
  const teclaF5disabled = () => {  //deactivamos la tecla f5
    //alert('teclaF5disabled');
    function disableF5(e:any)
    { if ((e.which || e.keyCode) === 116) e.preventDefault(); }
    $(document).on("keydown", disableF5);
  }

//*componente
  export default function PaginaSSC(){

    //*api store
      const { tokenStore, cnnStore } =  
        authenticateStore((state:any) =>( { tokenStore: state.tokenStore, cnnStore: state.cnnStore }),shallow);

      const { guardaGetSummarybyUserStore, notTotalStore,
              generaObjErrorNotificationsStore, 
              objErrorNotificationsStore, limpiaObjErrorNotificationsStore  } = 
        notificationsStore((state: any ) => ({
              guardaGetSummarybyUserStore: state.guardaGetSummarybyUserStore,
              notTotalStore: state.notTotalStore,
              notAvisosStore: state.notAvisosStore,
              notTotalAvisosStore: state.notTotalAvisosStore,
              notPendientesStore: state.notPendientesStore,
              notTotalPendienteStore: state.notTotalPendienteStore,
              generaObjErrorNotificationsStore: state.generaObjErrorNotificationsStore,
              objErrorNotificationsStore: state.objErrorNotificationsStore,
              limpiaObjErrorNotificationsStore: state.limpiaObjErrorNotificationsStore
      }));  

      const { objErrorUsersStore, limpiaObjErrorUsersStore } =  
        usersStore((state:any) =>( { objErrorUsersStore: state.objErrorUsersStore, limpiaObjErrorUsersStore: state.limpiaObjErrorUsersStore }));

      const { objErrorCatalogsStore, limpiaObjErrorCatalogsStore } =  
        catalogsStore((state:any) =>( { objErrorCatalogsStore: state.objErrorCatalogsStore, limpiaObjErrorCatalogsStore: state.limpiaObjErrorCatalogsStore }));
        //console.log('--objErrorCatalogsStore', objErrorCatalogsStore)

      const { objErrorProposalsStore, limpiaObjErrorProposalsStore } =  
        proposalsStore((state:any) =>( { objErrorProposalsStore: state.objErrorProposalsStore, limpiaObjErrorProposalsStore: state.limpiaObjErrorProposalsStore }));

      const { objErrorDecisionsStore, limpiaObjErrorDecisionsStore } =  
        decisionsStore((state:any) =>( { objErrorDecisionsStore: state.objErrorDecisionsStore, limpiaObjErrorDecisionsStore: state.limpiaObjErrorDecisionsStore }));

      const { objErrorPtCatalogsStore, limpiaObjErrorPtCatalogsStore } =  
        ptCatalogsStore((state:any) =>( { objErrorPtCatalogsStore: state.objErrorPtCatalogsStore, limpiaObjErrorPtCatalogsStore: state.limpiaObjErrorPtCatalogsStore }));

      const { objErrorFilesStore, limpiaObjErrorFilesStore } =  
        filesStore((state:any) =>( { objErrorFilesStore: state.objErrorFilesStore, limpiaObjErrorFilesStore: state.limpiaObjErrorFilesStore }));

      const { objErrorAnalysisStore, limpiaObjErrorAnalysisStore } =  
        analysisStore((state:any) =>( { objErrorAnalysisStore: state.objErrorAnalysisStore, limpiaObjErrorAnalysisStore: state.limpiaObjErrorAnalysisStore }));

      const { objErrorDashboardStore, limpiaObjErrorDashboardStore } =  
        dashboardStore((state:any) =>( { objErrorDashboardStore: state.objErrorDashboardStore, limpiaObjErrorDashboardStore: state.limpiaObjErrorDashboardStore }));

      const { objErrorConfigurationsStore, limpiaObjErrorConfigurationsStore } =  
        configurationsStore((state:any) =>( { objErrorConfigurationsStore: state.objErrorConfigurationsStore, limpiaObjErrorConfigurationsStore: state.limpiaObjErrorConfigurationsStore }));


    //*useState
      const [swRecarga, setSwRecarga] =  useState(false);
      const [swRecargaPaginaSSC, setSwRecargaPaginaSSC] =  useState(false); //usado para remasterizar esta página
      const [swRecargaNotifications, setSwRecargaNotifications] =  useState(false);
      const [cargandoSpin, setCargandoSpin] = useState(false);
      
    //*useEffect

      useEffect(()=> {  //cuando entramos limpiamos error
        //console.log('monto PaginaSSC... limpiaObjError...');
        limpiaObjErrorNotificationsStore();
        limpiaObjErrorUsersStore();
        limpiaObjErrorCatalogsStore();
        limpiaObjErrorProposalsStore();
        limpiaObjErrorDecisionsStore();
        limpiaObjErrorPtCatalogsStore();
        limpiaObjErrorFilesStore();
        limpiaObjErrorAnalysisStore();
        limpiaObjErrorDashboardStore();
        limpiaObjErrorConfigurationsStore();
      },[]);    

      useEffect(()=> {  //usado para renderizar
        //console.log('renderizando PaginaSSC.........................');
        setSwRecargaPaginaSSC(!swRecargaPaginaSSC);
      },[swRecarga]);   
      
      useEffect(()=> {  //llamada al API - Notifications/GetSummarybyUser // para obtener el total de notificaciones presentado a un lado de la campana
        //console.log("useEffect - API -Notifications/GetSummarybyUser****");
        setCargandoSpin(true);
        notificationsService.cargaGetSummarybyUser(tokenStore)
          .then(function(response:any){
              if (response.status==200){  //confirma que no hay error
                  guardaGetSummarybyUserStore(response.data).then( function(datos:any) { 
                    //console.log('cargo los datos de las notificaciones: ', datos );
                  })
              }
              setCargandoSpin(false);
          })
          .catch((ex) => {
              //ex.response.data.result.errores.map((: any) => (
              //toast.error(err.errorMessage)))
              //console.log ("--catch - ex (cargaGetSummarybyUser): ", ex);
              if (ex.response.status==404) //no es error solo no tiene información
                  console.log('nota: no es error solo no tiene información')
              else
                  generaObjErrorNotificationsStore(ex.response, true, '', '', 'PaginaSSC-notificationsService','PSSC')
              setCargandoSpin(false);
          })
      }, [swRecargaNotifications]);

    //*funciones
      
      teclaF5disabled(); //dehabilita la tecla f5
    
      const recargaPaginaSSC = () => { setSwRecarga(!swRecarga) } // con esto ejecuto un useEffect, lo uso para renderizar el front 
      
      const recargaPaginaSSC_Not = () => { setSwRecargaNotifications(!swRecargaNotifications) } //recarga la campana del encabezado 

    //*vista
      return (
        <>
          {/*genera la página SSC en 3 partes */}
            <div className='background-color-azul'>
                <div> <Encabezado tokenStore={tokenStore}
                                  notTotalStore={notTotalStore}
                                  recargaPaginaSSC_Not = {recargaPaginaSSC_Not}
                      /> 
                </div>
                <div> <Contenido tokenStore={tokenStore} 
                                 recargaPaginaSSC={recargaPaginaSSC} 
                                 recargaPaginaSSC_Not = {recargaPaginaSSC_Not}
                       /> 
                </div>
                <div> <Pie cnnStore={cnnStore} /> </div>
            </div>

          {/*ventana de error, en lectura de api */}
            { objErrorCatalogsStore.hasError  &&      <VentanaObjErrorAPI recurso="catalogs"       objError={objErrorCatalogsStore} />  }
            { objErrorProposalsStore.hasError &&      <VentanaObjErrorAPI recurso="proposals"      objError={objErrorProposalsStore} />  }
            { objErrorDecisionsStore.hasError &&      <VentanaObjErrorAPI recurso="decisions"      objError={objErrorDecisionsStore} />  }
            { objErrorPtCatalogsStore.hasError &&     <VentanaObjErrorAPI recurso="ptCatalogs"     objError={objErrorPtCatalogsStore} /> }
            { objErrorFilesStore.hasError  &&  
               (<>
                {window.scrollTo({top:0})};
               <VentanaObjErrorAPI recurso="files"          objError={objErrorFilesStore} /> 
               </>)
            }
            { objErrorAnalysisStore.hasError &&       <VentanaObjErrorAPI recurso="analysis"       objError={objErrorAnalysisStore} />  }
            { objErrorConfigurationsStore.hasError && <VentanaObjErrorAPI recurso="configurations" objError={objErrorConfigurationsStore} /> }
            { objErrorNotificationsStore.hasError &&  <VentanaObjErrorAPI recurso="notifications"  objError={objErrorNotificationsStore} /> } 
            { objErrorUsersStore.hasError &&          <VentanaObjErrorAPI recurso="users"          objError={objErrorUsersStore} /> } 
            { objErrorDashboardStore.hasError &&      <VentanaObjErrorAPI recurso="dashboard"      objError={objErrorDashboardStore} /> } 
        </>        
      );
  }